import Oystehr from '@oystehr/sdk';
import { Location } from 'fhir/r4b';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { isLocationInPerson } from 'utils/lib/fhir/location';
import { useApiClients } from '../../../../../hooks/useAppClients';
import { Option } from '../../../in-person/components/medication-administration/medicationTypes';

export const useLocationsOptions = (): {
  location: {
    options: Option[];
    status: 'loading' | 'loaded';
  };
} => {
  const [locationsOptions, setLocationsOptions] = useState<Option[]>([]);
  const [isLocationLoading, setIsLocationLoading] = useState(true);
  const { oystehr } = useApiClients();
  const { encounterId } = useParams();

  useEffect(() => {
    if (!oystehr) {
      return;
    }

    async function getLocationsResults(oystehr: Oystehr): Promise<void> {
      try {
        setIsLocationLoading(true);
        const locations = await oystehr.fhir.search<Location>({
          resourceType: 'Location',
          params: [{ name: '_count', value: '1000' }],
        });
        const locationsResults = Array.from(new Set(locations.entry))
          ?.filter((loc: any) => isLocationInPerson(loc.resource))
          .map((loc: any) => ({
            value: loc.resource?.name as string,
            label: loc.resource?.name as string,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));
        setLocationsOptions(locationsResults);
      } catch (e) {
        console.error('error loading locations', e);
      } finally {
        setIsLocationLoading(false);
      }
    }

    void getLocationsResults(oystehr);
  }, [encounterId, oystehr]);

  return {
    location: {
      options: locationsOptions,
      status: isLocationLoading ? 'loading' : 'loaded',
    },
  };
};
